import React, { useState, useEffect } from "react";
import {
  customName,
  getColorFromId,
  getColorFromEmail,
} from "../../helpers/commonHelpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const AttendeeDragDrop = ({
  attendees,
  updatedAttendeesData,
  setIsModalOpen,
  setRemoveAttendeeData,
  allowRemove,
}) => {
  const [draggingItem, setDraggingItem] = useState(null);
  const [items, setItems] = useState(attendees);

  useEffect(() => {
    setItems(attendees);
  }, [attendees]);

  const handleDragStart = (e, item) => {
    setDraggingItem(item);
    e.dataTransfer.setData("text/plain", "");
  };

  const handleDragEnd = () => {
    setDraggingItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetItem) => {
    if (!draggingItem) return;

    const currentIndex = items.indexOf(draggingItem);
    const targetIndex = items.indexOf(targetItem);

    if (currentIndex !== -1 && targetIndex !== -1) {
      items.splice(currentIndex, 1);
      items.splice(targetIndex, 0, draggingItem);
      setItems(items);
    }
    updatedAttendeesData(items);
  };

  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee.name} / {attendee?.email}
      </Tooltip>
    );
  };

  return (
    <div className="d-flex people att-people icon-container mb-2 create-meeting-attendee">
      {items.map((attendee, index) => {
        return (
          <div
            draggable="true"
            onDragStart={(e) => handleDragStart(e, attendee)}
            onDragEnd={handleDragEnd}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, attendee)}
            className="attendee-content drag-attendees"
            key={index}
          >
            {allowRemove ? (
              <OverlayTrigger
                placement="top"
                overlay={tooltip(attendee)}
                trigger={["hover", "focus"]}
                delay={{ show: 350, hide: 50 }}
              >
           
                <div
                  className="attendee attendee-list sl attendee-list-circle"
                  style={{
                    backgroundColor: attendee?.profilePicture ? undefined : attendee._id ? getColorFromId(attendee._id) : getColorFromEmail(attendee.email),
                 
                  }}
                  onClick={() => {
                    setIsModalOpen(true);
                    setRemoveAttendeeData(attendee);
                  }}
                >
                  {attendee?.profilePicture ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                      alt=""
                      className="attendee-profile-picture icon-image attendee-list-circle-img"
                      style={{
        
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                         e.target.parentElement.style.backgroundColor =
                                              getColorFromId(attendee._id);
                                            e.target.parentElement.innerText =
                                              customName(attendee?.name);
                      }}
                    />
                  ) : (
                    customName(attendee.name)
                  )}
                </div>
              </OverlayTrigger>
            ) : (
              <OverlayTrigger
                placement="top"
                overlay={tooltip(attendee)}
                trigger={["hover", "focus"]}
              >
                
                <div
                  className="attendee attendee-list sl attendee-list-circle"
                  style={{
                     backgroundColor: attendee?.profilePicture ? undefined : attendee._id ? getColorFromId(attendee._id) : getColorFromEmail(attendee.email),
                   
                  }}
             
                >
                  {attendee?.profilePicture ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                      alt=""
                     className="attendee-profile-picture icon-image attendee-list-circle-img"
                      style={{
                        
                      }}
                      onError={(e) => {
                       e.target.onerror = null;
                        e.target.style.display = "none";
                         e.target.parentElement.style.backgroundColor =
                                              getColorFromId(attendee._id);
                                            e.target.parentElement.innerText =
                                              customName(attendee?.name);
                      }}
                    />
                  ) : (
                    customName(attendee.name)
                  )}
                </div>
              </OverlayTrigger>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AttendeeDragDrop;
